class IcebergRestCatalog {}
class IcebergError extends Error {}

module.exports = {
  IcebergRestCatalog,
  IcebergError,
  default: {
    IcebergRestCatalog,
    IcebergError
  }
};
